import createForm from '@gef-ui/form-core/components/Form';
export default createForm('FormMaterial', [
    'FromMaterial'
]);
